import { __assign } from "tslib";
import React from "react";
import { MultipleFilterButton } from "./MultiFilterButton";
import { SingleFilterButton } from "./SingleFilterButton";
export function filterable(config) {
    return {
        getInfo: function () { return ({ name: "filterable" }); },
        onInjectColumn: function (renderColumn) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var columnResult = renderColumn(record, rowKey, recordIndex, column, columnIndex);
            // recordIndex > -1 是记录行，我们只注入表头
            if (recordIndex > -1) {
                return columnResult;
            }
            // 不是目标列
            if (column.key !== config.column) {
                return columnResult;
            }
            var children = columnResult.children;
            if (config.type === "single") {
                children = (React.createElement(SingleFilterButton, __assign({}, config), children));
            }
            else if (config.type === "multiple") {
                children = (React.createElement(MultipleFilterButton, __assign({}, config), children));
            }
            return __assign(__assign({}, columnResult), { children: children });
        }; },
    };
}
//# sourceMappingURL=filterable.js.map